const LOCAL_STORAGE_NOT_AVAILABLE_MESSAGE =
  "Local storage is not available in the current environment.";

export function getLocalStorage() {
  if (typeof window === "undefined" || !window.localStorage) {
    if (process.env.NODE_ENV !== "production") {
      console.warn(LOCAL_STORAGE_NOT_AVAILABLE_MESSAGE);
    }
    return null;
  }

  return window.localStorage;
}

export function clearStoragePreserving(keysToPreserve = []) {
  const storage = getLocalStorage();
  if (!storage) {
    return;
  }

  const preservedEntries = keysToPreserve.reduce((acc, key) => {
    acc[key] = storage.getItem(key);
    return acc;
  }, {});

  storage.clear();

  keysToPreserve.forEach((key) => {
    const value = preservedEntries[key];
    if (value !== null && value !== undefined) {
      storage.setItem(key, value);
    }
  });
}
